<section class="client-directory">
  <header class="client-directory__heading">
    <div>
      <span class="client-directory__eyebrow">CRM / {{ 'hx.client-list.title' | transloco }}</span>
      <h1>{{ 'hx.client-list.title' | transloco }}</h1>
      <p>{{ 'hx.client-list.subtitle' | transloco }}</p>
    </div>
    <div class="client-directory__hero-stat" aria-live="polite">
      <strong>{{ isLoading.list || loadFailed ? '—' : pagination.allItemCount }}</strong>
      <span>{{ 'hx.client-list.total' | transloco }}</span>
    </div>
  </header>

  <div class="client-directory__workspace">
    <div class="client-directory__toolbar">
      <form class="client-directory__search" (ngSubmit)="onSubmitFilter()">
        <label for="directory-search">{{ 'hx.client-list.filter.query' | transloco }}</label>
        <div class="client-directory__search-box">
          <i class="la la-search" aria-hidden="true"></i>
          <input id="directory-search" type="search" [(ngModel)]="searchDraft" name="search"
                 [placeholder]="'hx.client-list.placeholder.name' | transloco">
          <button type="submit" [disabled]="isLoading.list">{{ 'hx.client-list.btn.search' | transloco }}</button>
        </div>
      </form>
      <div class="client-directory__scope-filters">
        <div class="client-directory__filter" ngbDropdown #brandMenu="ngbDropdown">
          <span>{{ 'hx.client-list.filter.brand' | transloco }}</span>
          <button type="button" class="client-directory__select" ngbDropdownToggle [disabled]="isLoading.list">
            {{ selectedBrand?.title || ('hx.client-list.filter.brand' | transloco) }}
          </button>
          <div class="client-directory__menu" ngbDropdownMenu>
            <button type="button" *ngFor="let brand of brands" [class.is-selected]="brand.id === params.brandId"
                    (click)="selectBrand(brand.id); brandMenu.close()">{{ brand.title }}</button>
          </div>
        </div>
        <div class="client-directory__filter" ngbDropdown #countryMenu="ngbDropdown">
          <span>{{ 'hx.client-list.filter.country' | transloco }}</span>
          <button type="button" class="client-directory__select" ngbDropdownToggle [disabled]="isLoading.list">
            {{ (selectedCountry?.title | uiLabel) || ('hx.client-list.filter.country' | transloco) }}
          </button>
          <div class="client-directory__menu" ngbDropdownMenu>
            <button type="button" *ngFor="let country of availableCountries" [class.is-selected]="country.id === params.countryId"
                    (click)="selectCountry(country.id); countryMenu.close()">{{ country.title | uiLabel }}</button>
          </div>
        </div>
      </div>
    </div>

    <div class="client-directory__secondary">
      <div class="client-directory__birthday-group">
        <span class="client-directory__small-label">{{ 'hx.client-list.filter.birthDate' | transloco }}</span>
        <div class="client-directory__date-fields">
          <div class="client-directory__date-menu" ngbDropdown #dayMenu="ngbDropdown">
            <button type="button" class="client-directory__select client-directory__select--date" ngbDropdownToggle [disabled]="isLoading.list">
              {{ params.birthDay || ('hx.client-list.filter.day' | transloco) }}
            </button>
            <div class="client-directory__menu client-directory__menu--calendar" ngbDropdownMenu>
              <button type="button" class="client-directory__menu-clear" (click)="selectDay(undefined); dayMenu.close()">{{ 'hx.client-list.filter.anyDay' | transloco }}</button>
              <div class="client-directory__day-grid">
                <button type="button" *ngFor="let day of days" [class.is-selected]="day === params.birthDay"
                        (click)="selectDay(day); dayMenu.close()">{{ day }}</button>
              </div>
            </div>
          </div>
          <div class="client-directory__date-menu" ngbDropdown #monthMenu="ngbDropdown">
            <button type="button" class="client-directory__select client-directory__select--date" ngbDropdownToggle [disabled]="isLoading.list">
              {{ params.birthMonth ? (('hx.client-list.months.' + params.birthMonth) | transloco) : ('hx.client-list.filter.month' | transloco) }}
            </button>
            <div class="client-directory__menu client-directory__menu--months" ngbDropdownMenu>
              <button type="button" [class.is-selected]="!params.birthMonth" (click)="selectMonth(undefined); monthMenu.close()">{{ 'hx.client-list.filter.anyMonth' | transloco }}</button>
              <button type="button" *ngFor="let month of months" [class.is-selected]="month === params.birthMonth"
                      (click)="selectMonth(month); monthMenu.close()">{{ ('hx.client-list.months.' + month) | transloco }}</button>
            </div>
          </div>
        </div>
      </div>
      <button type="button" class="client-directory__reset" (click)="resetFilter()" [disabled]="isLoading.list || !hasActiveFilters">
        <i class="la la-undo" aria-hidden="true"></i> {{ 'hx.client-list.clear' | transloco }}
      </button>
    </div>

    <div class="client-directory__results-bar">
      <div>
        <h2>{{ 'hx.client-list.results' | transloco }}</h2>
        <p>{{ 'hx.client-list.scopeBrandCountry' | transloco }}</p>
      </div>
      <div class="client-directory__page-size" role="group" [attr.aria-label]="'hx.client-list.pageSize' | transloco">
        <span>{{ 'hx.client-list.pageSize' | transloco }}</span>
        <button type="button" *ngFor="let size of pageSizes" [class.is-selected]="params.limit === size"
                [disabled]="isLoading.list" (click)="params.limit = size; onLimitChanged()">{{ size }}</button>
      </div>
    </div>

    <div *ngIf="isLoading.list" class="client-directory__state" role="status">
      <span class="client-directory__spinner" aria-hidden="true"></span>
      <strong>{{ 'hx.client-list.loading' | transloco }}</strong>
    </div>
    <div *ngIf="loadFailed && !isLoading.list" class="client-directory__state client-directory__state--error" role="alert">
      <i class="la la-exclamation-circle" aria-hidden="true"></i>
      <strong>{{ 'hx.client-list.loadError' | transloco }}</strong>
      <small *ngIf="errorId">{{ 'hx.client-list.errorId' | transloco: {id: errorId} }}</small>
      <button type="button" (click)="loadList()">{{ 'hx.client-list.retry' | transloco }}</button>
    </div>
    <div *ngIf="!isLoading.list && !loadFailed && !list.length" class="client-directory__state client-directory__state--empty">
      <i class="la la-user-friends" aria-hidden="true"></i>
      <strong>{{ 'hx.client-list.emptyTitle' | transloco }}</strong>
      <p>{{ hasActiveFilters ? ('hx.client-list.emptyFiltered' | transloco) : ('hx.client-list.emptyBrandCountry' | transloco) }}</p>
      <button *ngIf="hasActiveFilters" type="button" (click)="resetFilter()">{{ 'hx.client-list.clear' | transloco }}</button>
    </div>

    <div class="client-directory__table-wrap" *ngIf="!isLoading.list && !loadFailed && list.length">
      <table class="client-directory__table">
        <thead><tr>
          <th scope="col">#</th>
          <th scope="col">{{ 'hx.client-list.table.head.name' | transloco }}</th>
          <th scope="col">{{ 'hx.client-list.table.head.num' | transloco }}</th>
          <th scope="col">{{ 'hx.client-list.table.head.happyDay' | transloco }}</th>
        </tr></thead>
        <tbody>
          <tr *ngFor="let item of list; let index = index" tabindex="0" role="button"
              (click)="updateItem(item)" (keydown.enter)="updateItem(item)" (keydown.space)="updateItem(item); $event.preventDefault()"
              [attr.aria-label]="('hx.client-list.open' | transloco) + ': ' + (item.client.fullname || item.client.phone || item.client.id)">
            <td class="client-directory__index">{{ (params.page - 1) * params.limit + index + 1 }}</td>
            <td><div class="client-directory__identity">
              <span class="client-directory__avatar" aria-hidden="true">{{ initials(item.client.fullname) }}</span>
              <span class="client-directory__name">{{ item.client.fullname || ('hx.client-list.noName' | transloco) }}</span>
            </div></td>
            <td class="client-directory__phone">{{ item.client.phone || ('hx.client-list.noPhone' | transloco) }}</td>
            <td class="client-directory__birth">
              <span *ngIf="item.client.birthDate; else noBirthDate">{{ item.client.birthDate | date: 'dd.MM.yyyy' }}</span>
              <ng-template #noBirthDate><span class="client-directory__muted">—</span></ng-template>
              <i *ngIf="item.birthDateUpdate" class="la la-info-circle client-directory__info"
                 [ngbTooltip]="'hx.client-list.ng.time' | transloco: {date: item.birthDateUpdate | date: 'dd.MM.yyyy HH:mm:ss'}"></i>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <footer class="client-directory__footer" *ngIf="!isLoading.list && !loadFailed && pagination.allItemCount > 0">
      <span>{{ 'hx.client-list.total' | transloco }} <strong>{{ pagination.allItemCount }}</strong></span>
      <ngb-pagination [maxSize]="5" [rotate]="true" [collectionSize]="pagination.allItemCount"
                      [(page)]="params.page" [pageSize]="params.limit" (pageChange)="pageChanged($event)"></ngb-pagination>
    </footer>
  </div>
</section>
